import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { brandPrimary, brandPrimaryText, header } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: 16,
	},
	dateSubtitle: {
		fontSize: 13,
		color: header,
		marginTop: 4,
	},
	actionRow: {
		display: 'flex',
		gap: THEME.spacing.sm,
		paddingLeft: THEME.spacing.md,
		paddingRight: THEME.spacing.md,
		justifyContent: 'center',
	},
	detailsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		padding: 16,
	},
	detailRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	label: {
		color: header,
		fontSize: 13,
		fontWeight: 600,
	},
	value: {
		fontSize: 13,
	},
	detailRowTop: {
		alignItems: 'flex-start',
	},
	locationValue: {
		fontSize: 13,
		textAlign: 'right',
		maxWidth: '50%',
		lineHeight: 1.4,
	},
	locationLink: {
		fontSize: 13,
		color: brandPrimaryText,
		':hover': {
			textDecoration: 'underline',
		},
	},
	participantsSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		padding: 16,
	},
	participantsSectionTitle: {
		color: brandPrimary,
		fontWeight: 600,
		fontSize: 14,
		margin: 0,
		marginBottom: 4,
	},
	participantRow: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '6px 0',
		gap: 12,
	},
	participantInfo: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		flex: 1,
		minWidth: 0,
	},
	participantNameRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
	},
	participantName: {
		fontSize: 13,
		fontWeight: 500,
	},
	hostBadge: {
		fontSize: 10,
		fontWeight: 600,
		color: brandPrimary,
		border: `1px solid ${brandPrimary}`,
		borderRadius: 4,
		padding: '1px 6px',
		textTransform: 'uppercase',
	},
	participantEmail: {
		fontSize: 11,
		color: header,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	emailRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		minWidth: 0,
	},
	copyButton: {
		border: 'none',
		background: 'none',
		padding: 0,
		cursor: 'pointer',
		flexShrink: 0,
		opacity: 0.5,
		':hover': {
			opacity: 1,
		},
	},
	participantTimezone: {
		fontSize: 11,
		color: header,
		fontStyle: 'italic',
	},
	participantComments: {
		fontSize: 12,
		color: header,
		fontStyle: 'italic',
		marginTop: 4,
		lineHeight: 1.4,
		whiteSpace: 'pre-wrap',
	},
	statusSelect: {
		minWidth: 140,
		flexShrink: 0,
		display: 'flex',
		justifyContent: 'flex-end',
	},
});
